import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../Header/Header'
import Aside from '../Aside/Aside'

import './Menu.scss'

const Menu = () => {
    const items = [
        { id: 1, src: '/images/icon-raspored.png', text: 'TV Raspored' },
        { id: 2, src: '/images/icon-moj-kutak.png', text: 'Moj TV kutak' },
        { id: 3, src: '/images/icon-postavke-white.png', text: 'Postavke', class: 'clickable', link: '/settings' },
        { id: 4, src: '/images/icon-yt.png', text: 'YouTube' },
        { id: 5, src: '/images/icon-yt-kids.png', text: 'YouTube Kids' },
        { id: 6, src: '/images/icon-pomoc.png', text: 'Pomoć' },
        { id: 7, src: '/images/icon-liste-programa.png', text: 'Liste programa' },
        { id: 8, src: '/images/icon-vodic.png', text: 'Vodič programa' },
        { id: 9, src: '/images/icon-trazilica.png', text: 'Tražilica' }
    ]

    return (
        <div className="menu">
            <div className="menu-body">
                <Header />
                <div className="menu-items">
                    {items.map(icon => {
                        return !!icon.link ? (
                            <Link to={icon.link} key={icon.id} className={`menu-icon ${icon.class}`}>
                                <img src={icon.src} alt={icon.text}></img>
                                <br />
                                <p>{icon.text}</p>
                            </Link>
                        ) : (
                            <div key={icon.id} className={`menu-icon ${icon.class}`}>
                                <img src={icon.src} alt={icon.text}></img>
                                <br />
                                <p>{icon.text}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
            <Aside leftLink="/" okLink="/settings" backLink="/" />
        </div>
    )
}

export default Menu
